import { Component, OnInit, Output, Input, ViewChild } from '@angular/core';
import { NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';

import { MatPaginator, PageEvent } from '@angular/material/paginator';

import { MatSort } from '@angular/material/sort';
import { finalize } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { FirebaseStorageService } from 'src/app/services/firebase-storage.service';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmReservationDialogComponent } from '../dialogs/confirm-reservation-dialog/confirm-reservation-dialog.component';
import { RangeDateComponent } from '../dialogs/range-date/range-date.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';
import { MonthpickerComponent } from '../dialogs/monthpicker/monthpicker.component';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'app-schools',
  templateUrl: './schools.component.html',
  styleUrls: ['./schools.component.sass']
})
export class SchoolsComponent implements OnInit {

  public yearperiodActive: boolean;

  schoolsListSubs: Subscription;
  schools: any;
  url: string;
  schoolsList: School[];
  schoolForm: FormGroup;
  showPrimarySpinner: boolean = false;
  isList: boolean = true;
  isNew: boolean = false;
  catalogsListSubs: Subscription;
  catalogs: any;
  yearperiodsListSubs: Subscription;
  yearperiods: any;
  filteredUsersListSubs: Subscription;
  filteredUsers: any;
  templatesListSubs: Subscription;
  templates_new_photo: any;
  templates_reminder: any;
  templates_order: any;
  // name = 'Angular ' + VERSION.major;
  // elementType = NgxQrcodeElementTypes.URL;
  correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  value: string;
  modification_date: string;
  creation_date: string;
  school_name: string;
  pageSize: number = 100;
  pageIndex: number = 0;
  selectedFiles: File;
  type_accept: string;
  role: any;
  pageEvent: PageEvent;
  index: number;
  displayedColumns: string[] = ['select', 'name', 'yearperiod', 'actions'];
  // dataSource = new MatTableDataSource<any>();
  dataSource: TableData = null;
  tableDataItems: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {}) sort: MatSort;
  @ViewChild('tabGroup') tabGroup;

  // TODO Substitute for a progress bar
  showSchoolprogressSpinner: boolean = false;

  // Currently only shown once table is already rendered.
  showSchoolProgressBar: boolean = false;

  public selection = new SelectionModel<any>(true, [])

  notificationType: any = "new_photo"

  constructor(
    public dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public firebaseStorageService: FirebaseStorageService,
    private translate: TranslateService,
    public dialog: MatDialog,
    private snackbar: MatSnackBar
  ) { }


  public getSchools() {
    var params = { 'catalogue': '', 'theme': '', 'search': '' }
    this.schoolsListSubs = this.dataService
      .getSchools(params)
      .subscribe(res => {
        this.schools = res;
        // ;
        //           this.usersList = res;
      },
        console.error
      );
  }

  public getCatalogs() {
    this.catalogsListSubs = this.dataService
      .getCatalogs()
      .subscribe(res => {
        this.catalogs = res;
        // ;
        //           this.usersList = res;
      },
        console.error
      );
  }

  public getYearperiods() {
    this.yearperiodsListSubs = this.dataService
      .getYearperiods()
      .subscribe(res => {
        this.yearperiods = res;
        // ;
        //           this.usersList = res;
      },
        console.error
      );
  }

  public getFilteredUsers(role: string) {
    var params = {};
    params['page'] = 1
    params['size'] = 5
    params['search'] = '';
    params['role'] = role;
    this.filteredUsersListSubs = this.dataService
      .getUsers(params)
      .subscribe(res => {
        this.filteredUsers = res;
        this.filteredUsers = [{ 'id': null, 'name': "" }].concat(this.filteredUsers)

      },
        console.error
      );
  }

  public masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource['items']);
  }

  public isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource['items'].length;
    return numSelected === numRows;
  }

  sendMassiveNotifications() {
    let threads = this.selection.selected.length

    let dataParams: any[] = []

    let finalMessage = ""

    for(let i = 0; i < this.selection.selected.length; i++) {

      let params = {}

      params['school_id'] = this.selection.selected[i].id
      params['stage_id'] = 'all'
      params['grade_id'] = ''

      if(this.notificationType == "new_photo")
      {
        params['template_id'] = this.selection.selected[i].template_new_photo._flat_path[1]
      }
      else
      {
        params['template_id'] = this.selection.selected[i].template_reminder._flat_path[1]
      }
      params['type'] = 'school'

      dataParams.push(params)

      let sub = this.dataService.checkSendNotifications(params).subscribe(res => {

        threads -= 1
        
        params['users_list'] = JSON.stringify(res.user_list);

        let message: any = this.translate.instant('alerts.checkNotifications').split('.')[0]
        
        this.showPrimarySpinner = false;
        message = this.selection.selected[i].name +": "+ message.replace('{{modify}}', res.num_emails)

        finalMessage += message+`
        \n`
        sub.unsubscribe()

        if(threads<= 0)
        {
          let dialogRef = this.dialog.open(ConfirmReservationDialogComponent, {
            data: {
              message: finalMessage,
              title: this.translate.instant('alerts.atention'),
              ok_txt: this.translate.instant('buttons.ok')
            }
          }).afterClosed().subscribe(res2 => {
    
            if (res2 === true) {
              this.showPrimarySpinner = true;
              
              for(let x = 0; x < dataParams.length; x++) {
                this.dataService.sendNotifications(dataParams[x]).subscribe(res3 => {
                  if (res3.status == 'ok') {
                    this.translate.get('alerts.sendNotifications_ok').subscribe(res4 => {
                      this.showPrimarySpinner = false;
                      this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000 })
                    })
                  }
                  else {
                    this.translate.get('alerts.send_notifications_error').subscribe(res4 => {
                      this.showPrimarySpinner = false;
                      this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000, panelClass: "error-snackbar" })
                    })
                  }
                })
              }
            }

            dialogRef.unsubscribe()
          })
        }
      })
    }
  }

  public getTemplates() {

    this.templatesListSubs = this.dataService
      .getTemplates()
      .subscribe(res => {
        let new_photo = [];
        let family = [];
        let order = [];
        for (let template in res) {

          if (res[template]['type'] == 'new_photo') {
            new_photo.push({ 'id': res[template]['id'], 'name': res[template]['name'] })
          }
          else if (res[template]['type'] == 'reminder') {
            family.push({ 'id': res[template]['id'], 'name': res[template]['name'] })
          }
          else if (res[template]['type'] == 'order') {
            order.push({ 'id': res[template]['id'], 'name': res[template]['name'] })
          }
          this.templates_new_photo = new_photo;
          this.templates_reminder = family;
          this.templates_order = order;
        }

      },
        console.error
      );
  }

  // ngAfterViewInit() {
  //   this.dataSource.sort = this.sort;
  //   this.dataSource.paginator = this.paginator;
  // }


  ngOnInit(): void {

    this.dataService.getRole().subscribe(res => {
      this.role = res
      if ((res != 'superadmin') && (res != 'admin')){
        this.router.navigate(['/schools']);
      }

    });
    this.type_accept = '.jpeg, .png, .jpg';

    this.getFilteredUsers('school')
    this.getTemplates()
    this.getCatalogs()
    this.getYearperiods()

    this.schoolForm = this.formBuilder.group({
      id: new FormControl(0, Validators.required),
      name: new FormControl('', Validators.required),
      // users: new FormControl(null, Validators.required),
      // email: new FormControl('', Validators.required),
      tpv_payment: new FormControl(false, Validators.required),
      language: new FormControl('es', Validators.required),
      template_new_photo: new FormControl('', Validators.required),
      template_reminder: new FormControl('', Validators.required),
      template_order: new FormControl('', Validators.required),
      yearperiods: new FormControl('', Validators.required),
      catalogs: new FormControl('', Validators.required),
      school_image: new FormControl(''),
      no_order: new FormControl(true),
      no_order_txt: new FormControl('Actualmente no hay productos disponibles para reservar/comprar'),
      no_order_txt_cat: new FormControl('Actualment no hi ha productes disponibles per reservar/comprar'),
      no_order_txt_en: new FormControl('There are currently no products available to reserve/buy'),
      notification: new FormControl(true),
      notification_txt: new FormControl(''),
      notification_txt_cat: new FormControl(''),
      notification_txt_en: new FormControl(''),
      lab_school_id: new FormControl('', Validators.required),

    });


    this.route.params.subscribe(params => {

      if (params.id) {

        
        this.isList = false;
        if (params.id != 'new') {
          this.isNew = false;
          this.schoolsListSubs = this.dataService
            .getSchool(params.id) //cambiar por id en el html
            .subscribe(res => {
              this.schools = res;

              this.yearperiodActive = this.schools.activated === false ? false : true

              this.schoolForm.controls["id"].setValue(this.schools.id);
              this.schoolForm.controls["name"].setValue(this.schools.name);
              // if (this.schools.user != null){
              //   this.schoolForm.controls["users"].setValue(this.schools.user._flat_path[1].toString());
              // }
              // else{
              //   this.schoolForm.controls["users"].setValue(null)
              // }
              // this.schoolForm.controls["email"].setValue(this.schools.email);
              this.schoolForm.controls["tpv_payment"].setValue(this.schools.tpv_payment);
              this.schoolForm.controls["language"].setValue(this.schools.language);
              this.schoolForm.controls["template_new_photo"].setValue(this.schools.template_new_photo._flat_path[1].toString());
              this.schoolForm.controls["template_reminder"].setValue(this.schools.template_reminder._flat_path[1].toString());
              this.schoolForm.controls["template_order"].setValue(this.schools.template_order._flat_path[1].toString());
              this.schoolForm.controls["yearperiods"].setValue(this.schools.yearperiod._flat_path[1].toString());
              this.schoolForm.controls["catalogs"].setValue(this.schools.catalogue._flat_path[1].toString());
              this.schoolForm.controls["school_image"].setValue(this.schools.school_image);
              this.schoolForm.controls["no_order"].setValue(this.schools.no_order);
              this.yearperiodActive ? '' : this.schoolForm.controls["no_order"].disable();
              this.schoolForm.controls["no_order_txt"].setValue(this.schools.no_order_txt);
              this.schoolForm.controls["no_order_txt_en"].setValue(this.schools.no_order_txt_en);
              this.schoolForm.controls["no_order_txt_cat"].setValue(this.schools.no_order_txt_cat);
              this.schoolForm.controls["notification_txt"].setValue(this.schools.notification_txt);
              this.schoolForm.controls["notification_txt_en"].setValue(this.schools.notification_txt_en);
              this.schoolForm.controls["notification_txt_cat"].setValue(this.schools.notification_txt_cat);
              this.schoolForm.controls["lab_school_id"].setValue(this.schools.lab_school_id);

              // this.value = `${environment.WEB_URL}/public/` + this.schools.id;
              this.modification_date = this.schools.modification_date;
              this.creation_date = this.schools.creation_date;
              this.school_name = this.schools.name;




            },
              console.error
            );
        }
        else {
          this.isNew = true;
        }


      }
      else {
        this.isList = true;
        this.initDataSource();

      }
    });
  }

  ngAfterViewInit() {
    this.route.params.subscribe(params => {
      if (params.tabid){
        this.changeIndexSelected(params.tabid)
      }
    })
  }


  goTo(schoolID: string) {
    let data = {}
    data['page'] = this.paginator.pageIndex+1
    data['pageSize'] = this.paginator.pageSize
    data['search'] = (<HTMLInputElement>document.getElementById("input")).value;
    localStorage.setItem('schools', JSON.stringify(data))
    this.router.navigateByUrl(`school/${schoolID}`);
  }

  changeIndexSelected(index){
    this.tabGroup.selectedIndex = Number(index);
  }

  sendNotifications(schoolID: string) {
    // this.router.navigate([]).then(result => { window.open(`public/${schoolID}`, '_blank'); });
    this.router.navigateByUrl(`send-notifications/school/${schoolID}`);
    // alert("in construction");
  }

  processOrders(schoolID: string) {
     this.dataService.checkDeactivateOrders(schoolID, 'school').subscribe(response => {
      if (response.status == "ok") {
        this.router.navigateByUrl(`process-orders/school/${schoolID}`);
      }
      else{
        this.translate.get('alerts.deactivate_orders_required').subscribe(r => {
          alert(r);
        })
      }
    })
  }

  getStudentsExcel(id: string, name: string) {
    let params = {
      'id': id
    }
    let sub = this.dataService.getStudents(params).subscribe((res: any) => {
      console.log(res)
      
      if(res && res.length>0) {
        let fileContent = "id;name;list number;stage;grade;\n"

        for(let i=0; i<res.length; i++) {
          let student = res[i]

          fileContent += `ID: ${student.id};${student.name};${student.list_number};${student.stage};${student.grade};\n`
        }

        let fileName = name + '-' + new Date().toTimeString() + '.csv';
        // let fileContent = JSON.stringify( {name: "test name"} );
      
        const file = new Blob([fileContent], { type: "text/csv" });
      
        const link = document.createElement("a");
        link.href = URL.createObjectURL(file);
        link.download = fileName;
        link.click();
        link.remove(); 
      }
      else {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant('alerts.list_students'), duration: 4000 })
      }

      sub.unsubscribe()
    })
  }

  uploadStudents(schoolID: string) {
    // this.router.navigate([]).then(result => { window.open(`public/${schoolID}`, '_blank'); });
    this.router.navigateByUrl(`upload-students/${schoolID}`);
    // alert("in construction");
  }
  uploadImages(schoolID: string) {
    // this.router.navigate([]).then(result => { window.open(`public/${schoolID}`, '_blank'); });
    this.router.navigateByUrl(`upload-images/${schoolID}`);
    // alert("in construction");
  }


  getSchoolReport(schoolID: string){
    let dialogRef = this.dialog.open(RangeDateComponent, {

    }).afterClosed().subscribe(res => {
      
      this.dataService.getSchoolReport(schoolID, '', res.start_date, res.end_date).subscribe(response => {
        if (response.status == 'success'){
          this.translate.get('alerts.report_send').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
          })
        }
        else if(response.msg && response.msg.includes('email')) {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant('alerts.email_format'), duration: 4000, panelClass: "error-snackbar"  })
        }
        else{
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 9000 })
        }
      })
    })
  }

  getMakneticReport(schoolID: string, type: string){
    let dialogRef = this.dialog.open(RangeDateComponent, {

    }).afterClosed().subscribe(res => {
      this.dataService.getMakneticReport(schoolID, type, res.start_date, res.end_date).subscribe(response => {
        if (response.status == 'success'){
          this.translate.get('alerts.report_send').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
          })
        }
      })
    })
  }

  getRangeDate(){
     // We throw a confirm action popup
     let dialogRef = this.dialog.open(RangeDateComponent, {

    }).afterClosed().subscribe(res => {
      if (res) {
        this.dataService.getAgencyReport(res).subscribe(response => {
          if (response.status == 'success'){
            this.translate.get('alerts.report_send').subscribe((res: string) => {
              this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
            })
          }
          else if(response.msg.includes('empty') || response.msg.includes('Empty')) {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant('alerts.no_data_found'), duration: 4000, panelClass: "error-snackbar" })
          }
        })

      }
    })
  }

  getMonth(){
     // We throw a confirm action popup
     let dialogRef = this.dialog.open(MonthpickerComponent, {

    }).afterClosed().subscribe(res => {
      if (res) {
        this.translate.get('alerts.process_background').subscribe((text: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: text, duration: 4000 })
        })
        this.dataService.sendInvoiceZip(res).subscribe(response => {
          if (response.status == 'success'){
            this.translate.get('alerts.invoices_zip_send_ok').subscribe((text2: string) => {
              this.snackbar.openFromComponent(CustomPopupComponent, { data: text2, duration: 4000 })
            })
          }
          else if(response.msg && response.msg.includes('email')) {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant('alerts.email_format'), duration: 4000, panelClass: "error-snackbar"  })
          }
          else{
            this.translate.get('alerts.invoices_not_found').subscribe((text2: string) => {
              this.snackbar.openFromComponent(CustomPopupComponent, { data: text2, duration: 4000, panelClass: "error-snackbar"  })
            })
          }
        })

      }
    })
  }

  switchActiveOrder(school_id: any) {
    let params = {}
    params['id'] = school_id
  
    this.dataService.updateSchoolActiveOrders(params).subscribe(res => {
      
      if(res == '' || res == undefined)
      {
        let data = {}
        data['page'] = this.paginator.pageIndex+1
        data['pageSize'] = this.paginator.pageSize
        localStorage.setItem('schools', JSON.stringify(data))
        this.initDataSource()
      }
      else
      {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant('alerts.no_permissions'), duration: 4000, panelClass: "error-snackbar" })
      }
    })
   }

  sendToFtp(schoolID: string) {
    // We first check if the school has the deactivated orders
    this.dataService.checkDeactivateOrders(schoolID, 'school').subscribe(response => {
      if (response.status == "ok") {
        let popup_content = {}

        this.translate.get('alerts.atention').subscribe(res => {
          popup_content['title'] = res;
        })

        this.translate.get('alerts.confirm_send_to_ftp').subscribe(res => {
          popup_content['message'] = res;
        })

        this.translate.get('buttons.ok').subscribe(res => {
          popup_content['ok_txt'] = res;
        })
        // We throw a confirm action popup
        let dialogRef = this.dialog.open(ConfirmReservationDialogComponent, {
          data: {
            title: popup_content['title'],
            message: popup_content['message'],
            ok_txt: popup_content['ok_txt']
          }
        }).beforeClosed().subscribe(res => {

          if (res) {
            // this.showPrimarySpinner = true
            // Call backend to change param of deleted to "true"
            this.translate.get('alerts.process_background').subscribe(r => {
              alert(r);
            })
            this.dataService.sendToFtp(schoolID).subscribe(data => {
              // If succesfull
              // this.showPrimarySpinner = false;
              if (data.status == "success") {
                // this.translate.get('alerts.process_background').subscribe(r => {
                //   alert(r);
                // })

              }
              else if (data.status == "empty") {
                this.translate.get('alerts.no_orders_found').subscribe(r => {
                  alert(r);
                })
              }
            })
          }
        })
      }
      else {
        this.translate.get('alerts.deactivate_orders_required').subscribe(r => {
          alert(r);
        })
      }
    })
  }

  sendToLab(schoolID: string) {
    // We first check if the school has the deactivated orders
    this.dataService.checkDeactivateOrders(schoolID, 'school').subscribe(response => {
      if (response.status == "ok") {
        let popup_content = {}

        this.translate.get('alerts.atention').subscribe(res => {
          popup_content['title'] = res;
        })

        this.translate.get('alerts.confirm_send_to_lab').subscribe(res => {
          popup_content['message'] = res;
        })

        this.translate.get('buttons.ok').subscribe(res => {
          popup_content['ok_txt'] = res;
        })
        // We throw a confirm action popup
        let dialogRef = this.dialog.open(ConfirmReservationDialogComponent, {
          data: {
            title: popup_content['title'],
            message: popup_content['message'],
            ok_txt: popup_content['ok_txt']
          }
        }).beforeClosed().subscribe(res => {

          if (res) {
            // this.showPrimarySpinner = true
            // Call backend to change param of deleted to "true"
            this.translate.get('alerts.process_background').subscribe(r => {
              alert(r);
            })
            this.dataService.sendToLab(schoolID).subscribe(data => {
              // If succesfull
              // this.showPrimarySpinner = false;
              if (data.status == "success") {
                // this.translate.get('alerts.process_background').subscribe(r => {
                //   alert(r);
                // })

              }
              else if (data.status == "empty") {
                this.translate.get('alerts.no_orders_found').subscribe(r => {
                  alert(r);
                })
              }
            })
          }
        })
      }
      else {
        this.translate.get('alerts.deactivate_orders_required').subscribe(r => {
          alert(r);
        })
      }
    })
  }

  downloadZipPhotos(schoolID: string) {
    // We first check if the school has the deactivated orders
    this.dataService.checkDeactivateOrders(schoolID, 'school').subscribe(response => {
      if (response.status == "ok") {
        let popup_content = {}

        this.translate.get('alerts.atention').subscribe(res => {
          popup_content['title'] = res;
        })

        this.translate.get('alerts.confirm_send_to_lab').subscribe(res => {
          popup_content['message'] = res;
        })

        this.translate.get('buttons.ok').subscribe(res => {
          popup_content['ok_txt'] = res;
        })
        // We throw a confirm action popup
        let dialogRef = this.dialog.open(ConfirmReservationDialogComponent, {
          data: {
            title: popup_content['title'],
            message: popup_content['message'],
            ok_txt: popup_content['ok_txt']
          }
        }).beforeClosed().subscribe(res => {

          if (res) {
            // this.showPrimarySpinner = true
            // Call backend to change param of deleted to "true"
            this.translate.get('alerts.process_background').subscribe(r => {
              alert(r);
            })
            this.dataService.sendToLab(schoolID).subscribe(data => {
              // If succesfull
              // this.showPrimarySpinner = false;
              if (data.status == "success") {
                // this.translate.get('alerts.process_background').subscribe(r => {
                //   alert(r);
                // })

              }
              else if (data.status == "empty") {
                this.translate.get('alerts.no_orders_found').subscribe(r => {
                  alert(r);
                })
              }
            })
          }
        })
      }
      else {
        this.translate.get('alerts.deactivate_orders_required').subscribe(r => {
          alert(r);
        })
      }
    })
  }

  newSchool() {
    this.router.navigateByUrl(`school/new`);
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
  }


  saveSchool() {
    var params = {};
    params['id'] = this.schoolForm.controls["id"].value;
    params['name'] = this.schoolForm.controls["name"].value;
    // params['user_id'] = this.schoolForm.controls["users"].value;
    // params['email'] = this.schoolForm.controls["email"].value;
    params['tpv_payment'] = this.schoolForm.controls["tpv_payment"].value;
    params['language'] = this.schoolForm.controls["language"].value;
    params['template_new_photo'] = this.schoolForm.controls["template_new_photo"].value;
    params['template_reminder'] = this.schoolForm.controls["template_reminder"].value;
    params['template_order'] = this.schoolForm.controls["template_order"].value;
    params['yearperiod_id'] = this.schoolForm.controls["yearperiods"].value;
    params['catalogue_id'] = this.schoolForm.controls["catalogs"].value;
    params['no_order'] = this.schoolForm.controls["no_order"].value;
    params['no_order_txt'] = this.schoolForm.controls["no_order_txt"].value;
    params['no_order_txt_en'] = this.schoolForm.controls["no_order_txt_en"].value;
    params['no_order_txt_cat'] = this.schoolForm.controls["no_order_txt_cat"].value;
    params['notification_txt'] = this.schoolForm.controls["notification_txt"].value;
    params['notification_txt_en'] = this.schoolForm.controls["notification_txt_en"].value;
    params['notification_txt_cat'] = this.schoolForm.controls["notification_txt_cat"].value;
    params['lab_school_id'] = this.schoolForm.controls["lab_school_id"].value;

    if (params['name'] == '') {
      this.translate.get('alerts.name_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
        
      })
      return false;
    }
    if ((params['lab_school_id'] == '') || (params['lab_school_id'] == 'undefined')) {
      this.translate.get('alerts.lab_school_id_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
        
      })
      return false;
    }
    if (this.selectedFiles) {
      const filePath = 'schools/' + params['name'];
      const storageRef = this.firebaseStorageService.referenciaCloudStorage(filePath);
      const uploadTask = this.firebaseStorageService.tareaCloudStorage(filePath, this.selectedFiles[0]);
      uploadTask.snapshotChanges().pipe(
        finalize(() => {
          params['url'] = filePath

          this.dataService.saveSchool(params).subscribe(data => {
            
            if (data == '') {
              this.router.navigateByUrl(`schools`);
            }
            else {
              this.translate.get('alerts.save_school_error').subscribe((res: string) => {
                this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
              })
            }
            this.showSchoolProgressBar = false
          })

        })
      ).subscribe();
    }
    else {
      params['url'] = ''
      this.dataService.saveSchool(params).subscribe(data => {
        
        if (data == '') {
          this.router.navigateByUrl(`schools`);
        }
        else {
          this.translate.get('alerts.save_school_error').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          })
        }
      })
    }
  }
  duplicate_school(school_id: string) {
    let popup_content = {}

    this.translate.get('alerts.atention').subscribe(res => {
      popup_content['title'] = res;
    })

    this.translate.get('alerts.confirm_duplicate_school').subscribe(res => {
      popup_content['message'] = res;
    })

    this.translate.get('buttons.ok').subscribe(res => {
      popup_content['ok_txt'] = res;
    })
    // We throw a confirm action popup
    let dialogRef = this.dialog.open(ConfirmReservationDialogComponent, {
      data: {
        title: popup_content['title'],
        message: popup_content['message'],
        ok_txt: popup_content['ok_txt']
      }
    }).beforeClosed().subscribe(res => {

      if (res) {
        // this.showPrimarySpinner = true
        // Call backend to change param of deleted to "true"
        this.translate.get('alerts.background_process').subscribe((res: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000})
        })
        this.dataService.duplicate_school(school_id).subscribe(data => {
          // If succesfull
          // this.showPrimarySpinner = false;
          if (data.status == "success") {
            this.translate.get('alerts.success').subscribe((res: string) => {
              this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000})
            })

          }
          else {
            this.translate.get('alerts.error').subscribe((res: string) => {
              this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
            })
          }

        })


      }


    })
  }

  changeFilter(event, input) {

    this.showSchoolProgressBar = true

    var params = {};
    params['page'] = 1
    params['size'] = this.pageSize
    params['search'] = (<HTMLInputElement>document.getElementById("input")).value;
        
    this.pageIndex = 0
    this.paginator.pageIndex = 0
    
    this.dataService.getSchools(params).pipe(
      map((schoolData: TableData) => this.dataSource = schoolData)
    ).subscribe(() => this.showSchoolProgressBar = false)
  }

  initDataSource() {

    this.showSchoolprogressSpinner = true;

    var params = {};

    params['page'] = 1
    params['size'] = this.pageSize
    params['search'] = '';

    if(localStorage.getItem('schools'))
    {
      let data = JSON.parse(localStorage.getItem('schools'))

      this.pageSize = data.pageSize
      this.pageIndex = data.page-1

      params['page'] = this.pageIndex+1
      params['size'] = this.pageSize
      params['search'] = data.search? data.search : ''
    }

    this.dataService.getSchools(params).pipe(
      // TODO Review change of type of shool data.
      // Was previously "TableData" but for some reason the data received has different model.
      map((schoolData: TableData) => {
        this.dataSource = schoolData
      })
    ).subscribe(() => this.showSchoolprogressSpinner = false)
  }

  onPaginateChange(event: PageEvent) {

    this.showSchoolProgressBar = true

    this.pageSize = event.pageSize
    var params = {};

    params['page'] = event.pageIndex + 1
    params['size'] = this.pageSize
    params['search'] = (<HTMLInputElement>document.getElementById("input")).value;

    
    this.dataService.getSchools(params).pipe(
      map((schoolData: TableData) => this.dataSource = schoolData)
    ).subscribe(() => this.showSchoolProgressBar = false)

    // let page = event.pageIndex;
    // let size = event.pageSize;

    // page = page + 1;

    // var params={};
    // params['catalogue'] = this.filterForm.controls["catalogue"].value;
    // params['theme'] = this.filterForm.controls["theme"].value;
    // params['page'] = page;
    // params['size'] = size;
    // this.dataService.getSchools(params).subscribe(schools => {
    //   this.schools = schools;
    //   this.dataSource.data = this.schools;

    //   // this.dataSource.filter = '';


    // });
  }
  addStage() {
    alert("In construction...")
  }

  replicateSchool() {
    alert("In construction...")
  }


  public onYearperiodChange(yearperiod: any){
    let selected;
    this.yearperiods.forEach(yp => {
      if(yp.id==yearperiod.value){
        selected = yp
      }
    });
    this.yearperiodActive = selected.activated
    selected.activated === false ? this.schoolForm.controls["no_order"].disable() : this.schoolForm.controls["no_order"].enable();
  }

}


export class School {
  constructor(
    public name: string
  ) { }
}


export interface TableData {
  schools: School[];
  meta: {
    totalSchools: number;
    itemCount: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  },
  links: {
    first: string;
    previous: string;
    next: string;
    last: string;
  }
}
